//记得在 src\components\lang\zhLoad.js 里面添加对象
const collectionLandDeductionState = {
  msg: {
  }
};
export default collectionLandDeductionState



// WEBPACK FOOTER //
// ./src/page/bd/run/collectionLandDeductionState/lang/collectionLandDeductionState.en.js